"use strict";

var _objectWithoutProperties = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _taggedTemplateLiteral = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  margin-top: 8px;\n  margin-bottom: 0;\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formFeedbackText = void 0;

var _stylitas = require("@creditas/stylitas");

var feedbackSuccess = function feedbackSuccess(_ref) {
  var theme = _ref.theme;
  return (0, _stylitas.css)(_templateObject(), theme.bColorsuccess);
};

var feedbackError = function feedbackError(_ref2) {
  var theme = _ref2.theme;
  return (0, _stylitas.css)(_templateObject2(), theme.bColordanger);
};

var feedbackWarning = function feedbackWarning(_ref3) {
  var theme = _ref3.theme;
  return (0, _stylitas.css)(_templateObject3(), theme.bColorwarning);
};

var formFeedbackText = function formFeedbackText(_ref4) {
  var success = _ref4.success,
      error = _ref4.error,
      warning = _ref4.warning,
      props = _objectWithoutProperties(_ref4, ["success", "error", "warning"]);

  return (0, _stylitas.css)(_templateObject4(), _stylitas.utilities.typography.support(props.theme), success && feedbackSuccess(props), warning && feedbackWarning(props), error && feedbackError(props));
};

exports.formFeedbackText = formFeedbackText;